(function() {
    'use strict';

    angular
        .module('serviciosocialApp')
        .controller('SSModalidadDialogController', SSModalidadDialogController);

    SSModalidadDialogController.$inject = ['$timeout', '$scope', '$stateParams', '$uibModalInstance', 'entity', 'SSModalidad'];

    function SSModalidadDialogController ($timeout, $scope, $stateParams, $uibModalInstance, entity, SSModalidad) {
        var vm = this;

        vm.sSModalidad = entity;
        vm.clear = clear;
        vm.datePickerOpenStatus = {};
        vm.openCalendar = openCalendar;
        vm.save = save;

        $timeout(function (){
            angular.element('.form-group:eq(1)>input').focus();
        });

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function save () {
            vm.isSaving = true;
            if (vm.sSModalidad.id !== null) {
                SSModalidad.update(vm.sSModalidad, onSaveSuccess, onSaveError);
            } else {
                SSModalidad.save(vm.sSModalidad, onSaveSuccess, onSaveError);
            }
        }

        function onSaveSuccess (result) {
            $scope.$emit('serviciosocialApp:sSModalidadUpdate', result);
            $uibModalInstance.close(result);
            vm.isSaving = false;
        }

        function onSaveError () {
            vm.isSaving = false;
        }

        vm.datePickerOpenStatus.altaReg = false;
        vm.datePickerOpenStatus.bajaReg = false;
        vm.datePickerOpenStatus.ultActReg = false;

        function openCalendar (date) {
            vm.datePickerOpenStatus[date] = true;
        }
    }
})();
